import { messagesManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [
  IRoleEnum.SUPER_ADMIN,
  IRoleEnum.Teacher,
  IRoleEnum.ASSISTANT,
];

const messagesManagementRouteMetadata: IRouteMetadataObj<
  typeof messagesManagementRoutesObj
> = {
  list: {
    title: "messages.index.title",
    description: "messages.index.description",
    lazy: () => import("@/pages/messages/table/page"),
    mode: "index",
    type: "main",
    icon: "Message3Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "messages.create.title",
    description: "messages.create.description",
    lazy: () => import("@/pages/messages/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
};

export const messagesManagementRoutes = createRoute<
  typeof messagesManagementRoutesObj
>(messagesManagementRoutesObj, messagesManagementRouteMetadata);
